<div role="dialog" aria-modal="true" aria-labelledby="modal-title-change-kind">
  <div class="modal-header">
    <h2 id="modal-title-change-kind" class="modal-title h4">Change Blueprint Kind</h2>
  </div>
  <form #ngForm="ngForm" (ngSubmit)="ngForm.valid && submit()">
    <div class="modal-body">
      <p>
        Changing the kind for blueprint <strong>{{ options?.planName }}</strong> (service
        <strong>{{ options?.serviceTreeId }}</strong>) will update the kind for <strong>all</strong> versions of this
        blueprint. This action does not modify regional plans that are already assigned. Please verify it is
        safe before proceeding.
      </p>
      <label style="width: 100%">
        <span>Current kind</span>
        <input type="text" class="form-control" [value]="options?.currentKind || ''" disabled />
      </label>
      <label style="width: 100%; margin-top: 12px">
        <span>Select the new blueprint kind</span>
        <ng-select
          name="newKind"
          [(ngModel)]="newKind"
          [items]="planKindList"
          bindValue="key"
          bindLabel="value"
          required
          data-test="newKind"></ng-select>
      </label>
    </div>
    <div class="modal-footer">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="isSubmitDisabled()"
        data-test="ChangeKindSubmit">
        Change Kind
      </button>
      <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cancel</button>
    </div>
  </form>
</div>
